import Dialog from "@mui/material/Dialog";
import styles from "./discard.module.scss";
import AppButton from "../button/button";
import Typography from "../typography/Typography";
import { palette } from "../../../styles/design-tokens";

export interface DialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly handleDiscard: () => void;
  readonly message?: string;
  readonly cancelButtonTitle?: string;
  readonly discardButtonLabel?: string;
  readonly hideDialogTitle?: boolean;
  readonly cancelFLight?: boolean;
}

function DiscardChanges(props: DialogProps): JSX.Element {
  const {
    onClose,
    open,
    handleDiscard,
    message,
    discardButtonLabel,
    cancelButtonTitle,
    hideDialogTitle,
    cancelFLight,
  } = props;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      className={styles.main}
      BackdropProps={{
        sx: {
          backgroundColor: palette["black-a85"],
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <div className={styles.container} data-id="discard-changes-dialog">
        {!hideDialogTitle && <span className={styles.title}>Discard Changes?</span>}
        {message ? (
          <Typography variant="span" weight={400} size="size14" className={styles.subTitle}>
            {message}
          </Typography>
        ) : (
          <Typography variant="span" weight={400} size="size14" className={styles.subTitle}>
            Your changes will be lost if
            <br /> you do not save them!
          </Typography>
        )}

        <div className={`${cancelFLight ? styles.cancelFLightBtnCard : styles.btnCard}`}>
          <AppButton onClick={onClose} variant="tertiary" size="sm">
            {cancelButtonTitle ?? "Cancel"}
          </AppButton>
          <AppButton className={styles.discBtn} onClick={handleDiscard} size="sm">
            {discardButtonLabel ?? " Discard Changes"}
          </AppButton>
        </div>
      </div>
    </Dialog>
  );
}

export default DiscardChanges;
